/**
 * @generated SignedSource<<4592331fc7092df3eb713eacdd6c82dc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type view_issueViewActivityComment_Avatar$data = {
  readonly me: {
    readonly user: {
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly " $fragmentType": "view_issueViewActivityComment_Avatar";
};
export type view_issueViewActivityComment_Avatar$key = {
  readonly " $data"?: view_issueViewActivityComment_Avatar$data;
  readonly " $fragmentSpreads": FragmentRefs<"view_issueViewActivityComment_Avatar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "view_issueViewActivityComment_Avatar",
  "selections": [
    {
      "concreteType": "AuthenticationContext",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "picture"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "bdd5e2829fad1b62130bf1dc3cc2daf2";

export default node;
